module.exports = __webpack_public_path__ + "img/sidenav-item-customer-history.2a62f493.svg";